module.exports = __webpack_public_path__ + "static/media/map.9fdf846e.svg";